import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-phone\"><path d=\"M762 64.2H262c-27.5 0-50 22.5-50 50v795.7c0 27.5 22.5 50 50 50h500c27.5 0 50-22.5 50-50V114.2c0-27.5-22.5-50-50-50zM272 668.4V124.2h480v544.3H272v-0.1z m0 231.4V728.4h480v171.4H272z\" fill=\"#606266\" p-id=\"12705\" /><path d=\"M512 768.4c-27.6 0-50 22.4-50 50s22.4 50 50 50 50-22.4 50-50-22.4-50-50-50z\" fill=\"#606266\" p-id=\"12706\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol